import {
    ArcRotateCamera,
    AssetContainer,
    Color3,
    Color4,
    Engine,
    GlowLayer,
    HemisphericLight,
    LensRenderingPipeline,
    Mesh,
    MeshBuilder,
    Scene,
    StandardMaterial,
    Texture,
    Vector3,
    VertexData
} from '@babylonjs/core';
import { AdvancedDynamicTexture, Control, Ellipse, Grid, Image, MultiLine, Rectangle, StackPanel, TextBlock } from '@babylonjs/gui';
import * as earcut from 'earcut';

export class Fu {
    public canvas: HTMLCanvasElement;
    public engine: Engine;
    public scene: Scene;
    public camera: ArcRotateCamera;
    public light: HemisphericLight;
    public advancedTexture: AdvancedDynamicTexture;
    public panelLeft: StackPanel;
    public panelRight: StackPanel;
    public cameraMaterial: StandardMaterial;
    public waringArea: StandardMaterial;
    public cameraLayer: AssetContainer;
    public eventCameraLayer: AssetContainer;
    public warningLayer: AssetContainer;

    public constructor(canvas, radius, target) {
        this.canvas = canvas;
        this.engine = new Engine(this.canvas);
        this.scene = new Scene(this.engine);
        this.cameraLayer = new AssetContainer(this.scene);
        this.warningLayer = new AssetContainer(this.scene);
        this.eventCameraLayer = new AssetContainer(this.scene);
        this.createBase(radius, target);
        this.createEvn();
        this.createMaterial();
        this.engine.runRenderLoop(() => {
            this.scene.render();
        });
        this.createAdvancedTexture();
        // this.createFrog();
    }

    public createAdvancedTexture() {
        this.advancedTexture = AdvancedDynamicTexture.CreateFullscreenUI('ui1');
        this.panelLeft = new StackPanel();
        this.panelRight = new StackPanel();
        this.panelLeft.width = '300px';
        this.panelRight.width = '300px';
        this.panelLeft.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
        this.panelRight.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_RIGHT;
        this.advancedTexture.addControl(this.panelLeft);
        this.advancedTexture.addControl(this.panelRight);
    }

    public createGUI(title, content, mesh, name, count) {
        const parentPane = count < 7 ? this.panelLeft : this.panelRight;
        const label = new Rectangle(name);
        label.background = 'rgba(0, 0, 0,.5)';
        label.height = '100px';
        label.width = '250px';
        label.cornerRadius = 5;
        label.thickness = 1;
        label.left = 0;
        label.paddingBottom = 8;
        label.paddingRight = 5;
        label.paddingLeft = 5;
        parentPane.addControl(label);

        const grid = new Grid();
        grid.width = '100%';
        grid.height = '100%';
        grid.addColumnDefinition(1);
        grid.addRowDefinition(30, true);
        grid.addRowDefinition(1, true);
        grid.addRowDefinition(1);
        label.addControl(grid);

        const rect = new Rectangle();
        rect.background = 'white';
        rect.thickness = 0;
        grid.addControl(rect, 1, 0);

        const startRound = new Ellipse();
        startRound.top = 38;
        count < 7 ? startRound.left = 110 : startRound.left = -110;
        startRound.background = 'black';
        startRound.width = '10px';
        startRound.height = '10px';
        startRound.color = 'white';
        label.addControl(startRound);

        const endRound = new Ellipse(name);
        endRound.width = '10px';
        endRound.background = 'white';
        endRound.height = '10px';
        endRound.color = 'white';
        this.advancedTexture.addControl(endRound);
        endRound.linkWithMesh(mesh);

        const ico = new Image('ico', '/assets/warning1.png');
        ico.width = '25px';
        ico.height = '25px';
        ico.left = '5px';
        ico.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
        grid.addControl(ico, 0 , 0);

        const titleBlock = new TextBlock();
        titleBlock.text = title;
        titleBlock.width = '100%';
        titleBlock.fontSize = 16;
        titleBlock.fontWeight = '600';
        titleBlock.left = 35;
        titleBlock.top = 2;
        titleBlock.textHorizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
        titleBlock.textVerticalAlignment = Control.VERTICAL_ALIGNMENT_CENTER;
        titleBlock.color = 'white';
        grid.addControl(titleBlock, 0 , 0);

        const contentBlock = new TextBlock();
        contentBlock.text = content;
        contentBlock.width = '100%';
        contentBlock.fontSize = 14;
        contentBlock.textWrapping = true;
        contentBlock.left = 5;
        contentBlock.top = 5;
        contentBlock.textHorizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
        contentBlock.textVerticalAlignment = Control.VERTICAL_ALIGNMENT_TOP;
        contentBlock.color = 'white';
        grid.addControl(contentBlock, 2 , 0);

        const line = new MultiLine(name);
        line.lineWidth = 1;
        line.color = 'red';
        line.add(startRound, mesh);
        this.advancedTexture.addControl(line);
    }

    public createBase(radius, target) {
        this.scene.clearColor = new Color4(0, 0, 0, 1);
        this.scene.collisionsEnabled = true;
        this.camera = new ArcRotateCamera('camera1', Math.PI / 2, Math.PI / 4, radius, target, this.scene);
        this.camera.upperBetaLimit = Math.PI / 2.1;
        // åæºå¯ä»¥æè¿çæå¤§è·ç¦»
        this.camera.upperRadiusLimit = radius * 1.2;
        // åæºå¯ä»¥æè¿çåå¾
        this.camera.lowerRadiusLimit = 2;
        this.camera.wheelDeltaPercentage = 0.01;
        // å¼å¯åæºç¢°ææ£æµ
        this.camera.checkCollisions = true;
        // è®¾ç½®ç¢°æåå¾
        this.camera.collisionRadius = new Vector3(1.5, 1.5, 1.5);
        // å¼å¯ç¸æºçå¼¹è·³è¡ä¸º
        // this.camera.useBouncingBehavior = true;
        // å¼å¯ç¸æºçFramingè¡ä¸º
        // this.camera.useFramingBehavior = true;
        // æ äº¤äºæ¶èªå¨è½¬
        this.camera.useAutoRotationBehavior = true;
        this.camera.attachControl(this.canvas, true);
        const parameters = {
            // edge_blur: 3.0,
            // chromatic_aberration: 1.0,
            dof_aperture: 1,
            distortion: 0, // å¤±çç¨åº¦
            dof_pentagon: true,
            dof_gain: 1,
            dof_threshold: 1
            // etc.
        };
        const lensEffect = new LensRenderingPipeline('lensEffects', parameters, this.scene, 1, [this.camera]);
        this.light = new HemisphericLight('light1', new Vector3(0, 1, 0), this.scene);
        this.light.intensity = 0.7;
        const glow = new GlowLayer('glow', this.scene, {
            mainTextureFixedSize: 556,
            blurKernelSize: 32
        });
    }

    // åå»ºç¯å¢ç
    public createEvn() {
        const skyboxMaterial = new StandardMaterial('skyBox', this.scene);
        skyboxMaterial.backFaceCulling = false;
        skyboxMaterial.reflectionTexture = new Texture('/assets/skybox.jpg', this.scene);
        skyboxMaterial.reflectionTexture.coordinatesMode = Texture.FIXED_EQUIRECTANGULAR_MODE;
        skyboxMaterial.diffuseColor = new Color3(0, 0, 0);
        skyboxMaterial.specularColor = new Color3(0, 0, 0);
        const meshSpere = MeshBuilder.CreateSphere('skySphere', {diameter: 1000}, this.scene);
        meshSpere.material = skyboxMaterial;
    }

    // åå»ºé¾ææ
    public createFrog() {
        this.scene.fogMode = Scene.FOGMODE_LINEAR;
        this.scene.fogStart = 700;
        this.scene.fogEnd = 800;
    }

    // åå»ºxozçå¹³é¢
    // @ts-ignore
    public line2DXoZ(name, options) {

        // Arrays for vertex positions and indices
        const positions = [];
        const indices = [];
        let normals;

        const width = options.width / 2 || 0.5;
        const path = options.path;
        const closed = options.closed || false;
        let standardUV = true;
        if (options.standardUV === undefined) {
            standardUV = true;
        } else {
            standardUV = options.standardUV;
        }

        const outerData = [];
        const innerData = [];
        let angle = 0;

        const nbPoints = path.length;
        let line = Vector3.Zero();
        const nextLine = Vector3.Zero();
        path[1].subtractToRef(path[0], line);

        if (nbPoints > 2 && closed) {
            path[2].subtractToRef(path[1], nextLine);
            for (let p = 0; p < nbPoints; p++) {
                angle = Math.PI - Math.acos(Vector3.Dot(line, nextLine) / (line.length() * nextLine.length()));
                const direction = Vector3.Cross(line, nextLine).normalize().y;
                const lineNormal = new Vector3(-line.z, 0, line.x).normalize();
                line.normalize();
                innerData[(p + 1) % nbPoints] = path[(p + 1) % nbPoints].subtract(lineNormal.scale(width))
                    .subtract(line.scale(direction * width / Math.tan(angle / 2)));
                outerData[(p + 1) % nbPoints] = path[(p + 1) % nbPoints].add(lineNormal.scale(width))
                    .add(line.scale(direction * width / Math.tan(angle / 2)));
                line = nextLine.clone();
                path[(p + 3) % nbPoints].subtractToRef(path[(p + 2) % nbPoints], nextLine);
            }
        } else {
            let lineNormal = new Vector3(-line.z, 0, line.x).normalize();
            line.normalize();
            innerData[0] = path[0].subtract(lineNormal.scale(width));
            outerData[0] = path[0].add(lineNormal.scale(width));

            for (let p = 0; p < nbPoints - 2; p++) {
                path[p + 2].subtractToRef(path[p + 1], nextLine);
                angle = Math.PI - Math.acos(Vector3.Dot(line, nextLine) / (line.length() * nextLine.length()));
                const direction = Vector3.Cross(line, nextLine).normalize().y;
                lineNormal = new Vector3(-line.z, 0, line.x).normalize();
                line.normalize();
                innerData[p + 1] = path[p + 1].subtract(lineNormal.scale(width))
                    .subtract(line.scale(direction * width / Math.tan(angle / 2)));
                outerData[p + 1] = path[p + 1].add(lineNormal.scale(width))
                    .add(line.scale(direction * width / Math.tan(angle / 2)));
                line = nextLine.clone();
            }
            if (nbPoints > 2) {
                path[nbPoints - 1].subtractToRef(path[nbPoints - 2], line);
                lineNormal = new Vector3(-line.z, 0, line.x).normalize();
                line.normalize();
                innerData[nbPoints - 1] = path[nbPoints - 1].subtract(lineNormal.scale(width));
                outerData[nbPoints - 1] = path[nbPoints - 1].add(lineNormal.scale(width));
            } else {
                innerData[1] = path[1].subtract(lineNormal.scale(width));
                outerData[1] = path[1].add(lineNormal.scale(width));
            }
        }

        let maxX = Number.MIN_VALUE;
        let minX = Number.MAX_VALUE;
        let maxZ = Number.MIN_VALUE;
        let minZ = Number.MAX_VALUE;

        for (let p = 0; p < nbPoints; p++) {
            positions.push(innerData[p].x, innerData[p].y, innerData[p].z);
            maxX = Math.max(innerData[p].x, maxX);
            minX = Math.min(innerData[p].x, minX);
            maxZ = Math.max(innerData[p].z, maxZ);
            minZ = Math.min(innerData[p].z, minZ);
        }

        for (let p = 0; p < nbPoints; p++) {
            positions.push(outerData[p].x, outerData[p].y, outerData[p].z);
            maxX = Math.max(innerData[p].x, maxX);
            minX = Math.min(innerData[p].x, minX);
            maxZ = Math.max(innerData[p].z, maxZ);
            minZ = Math.min(innerData[p].z, minZ);
        }

        for (let i = 0; i < nbPoints - 1; i++) {
            indices.push(i, i + 1, nbPoints + i + 1);
            indices.push(i, nbPoints + i + 1, nbPoints + i);
        }

        if (nbPoints > 2 && closed) {
            indices.push(nbPoints - 1, 0, nbPoints);
            indices.push(nbPoints - 1, nbPoints, 2 * nbPoints - 1);
        }

        normals = [];
        const uvs = [];

        if (standardUV) {
            for (let p = 0; p < positions.length; p += 3) {
                uvs.push((positions[p] - minX) / (maxX - minX), (positions[p + 2] - minZ) / (maxZ - minZ));
            }
        } else {
            let flip = 0;
            let p1;
            let p2;
            let p3;
            let v0 = innerData[0];
            let v1 = innerData[1].subtract(v0);
            let v2 = outerData[0].subtract(v0);
            let v3 = outerData[1].subtract(v0);
            let axis = v1.clone();
            axis.normalize();

            p1 = Vector3.Dot(axis, v1);
            p2 = Vector3.Dot(axis, v2);
            p3 = Vector3.Dot(axis, v3);
            minX = Math.min(0, p1, p2, p3);
            maxX = Math.max(0, p1, p2, p3);

            uvs[2 * indices[0]] = -minX / (maxX - minX);
            uvs[2 * indices[0] + 1] = 1;
            uvs[2 * indices[5]] = (p2 - minX) / (maxX - minX);
            uvs[2 * indices[5] + 1] = 0;

            uvs[2 * indices[1]] = (p1 - minX) / (maxX - minX);
            uvs[2 * indices[1] + 1] = 1;
            uvs[2 * indices[4]] = (p3 - minX) / (maxX - minX);
            uvs[2 * indices[4] + 1] = 0;

            for (let i = 6; i < indices.length; i += 6) {

                flip = (flip + 1) % 2;
                v0 = innerData[0];
                v1 = innerData[1].subtract(v0);
                v2 = outerData[0].subtract(v0);
                v3 = outerData[1].subtract(v0);
                axis = v1.clone();
                axis.normalize();

                p1 = Vector3.Dot(axis, v1);
                p2 = Vector3.Dot(axis, v2);
                p3 = Vector3.Dot(axis, v3);
                minX = Math.min(0, p1, p2, p3);
                maxX = Math.max(0, p1, p2, p3);

                uvs[2 * indices[i + 1]] = flip + Math.cos(flip * Math.PI) * (p1 - minX) / (maxX - minX);
                uvs[2 * indices[i + 1] + 1] = 1;
                uvs[2 * indices[i + 4]] = flip + Math.cos(flip * Math.PI) * (p3 - minX) / (maxX - minX);
                uvs[2 * indices[i + 4] + 1] = 0;
            }
        }

        VertexData.ComputeNormals(positions, indices, normals);
        VertexData._ComputeSides(Mesh.DOUBLESIDE, positions, indices, normals, uvs);
        // Create a custom mesh
        const customMesh = new Mesh(name, this.scene);

        // Create a vertexData object
        const vertexData = new VertexData();

        // Assign positions and indices to vertexData
        vertexData.positions = positions;
        vertexData.indices = indices;
        vertexData.normals = normals;
        vertexData.uvs = uvs;

        // Apply vertexData to custom mesh
        vertexData.applyToMesh(customMesh);

        return customMesh;

    }

    // ç»åºè­¦ååºå
    public drawWarning(areaName, positions, floor, globalScaling) {
        if (!this.scene.getMeshByName(areaName)) {
            const mode = MeshBuilder.ExtrudePolygon(areaName, {shape: positions, depth: 7.5}, this.scene, earcut);
            mode.scaling = globalScaling;
            mode.material = this.waringArea;
            mode.position.y = 0.75 * floor - 0.01;
            this.warningLayer.meshes.push(mode);
        } else {
            //
        }
    }

    // åå»ºæåå¤´
    public createCamera(name, position: Vector3, isEvent?: boolean) {
        if (this.scene.getMeshByName(name)) {
            return this.scene.getMeshByName(name);
        } else {
            const camera = MeshBuilder.CreateSphere(name, {diameter: 0.2}, this.scene);
            camera.position = position;
            camera.material = this.cameraMaterial;
            isEvent ? this.eventCameraLayer.meshes.push(camera) : this.cameraLayer.meshes.push(camera);
            return camera;
        }
    }

    // åå»ºæéçæè´¨
    public createMaterial() {
        // æåå¤´æè´¨
        const cameraMaterial = new StandardMaterial('', this.scene);
        cameraMaterial.emissiveColor = Color3.Green();
        cameraMaterial.alpha = 0.3;
        this.cameraMaterial = cameraMaterial;
        // åè­¦åºåæè´¨
        const waringArea = new StandardMaterial('xray', this.scene);
        waringArea.opacityTexture = new Texture('assets/alphaText.png', this.scene);
        waringArea.pointsCloud = true;
        waringArea.emissiveColor = Color3.Red();
        waringArea.backFaceCulling = false;
        this.waringArea = waringArea;
    }
}
